import { stdObject } from "../../../data/types/stdObject";
import InnerTable from "./InnerTable";
import { useEffect } from "react";
import EditableItem from "./EditableItem";
import PageRuler, { rulerSize } from "./PageRuler";
import { useStationeryContext } from "../../../context/MainContext";

export default function PageModel() {
  const {
    isPrint,
    isDoc,
    paperData,
    actives,
    deskDiv,
    pageDiv,
    flexDir,
    scaleInfo,
    resizeZoom,
    resizePage,
    pages,
    printArea,
    hasTicket,
  } = useStationeryContext();

  useEffect(() => {
    resizePage();
  }, []);

  // Ctrl + mouse wheel (or trackpad pinch) zooms the page. Native listener
  // because React registers wheel handlers as passive and can't preventDefault.
  useEffect(() => {
    const desk = deskDiv.current;
    if (!desk) return;
    const onWheel = (ev: WheelEvent) => {
      if (!ev.ctrlKey || ev.deltaY === 0) return;
      ev.preventDefault();
      const delta = ev.deltaMode === 1 ? ev.deltaY * 33 : ev.deltaY;
      resizeZoom(delta < 0, Math.min(Math.abs(delta), 100) / 1000);
    };
    desk.addEventListener("wheel", onWheel, { passive: false });
    return () => desk.removeEventListener("wheel", onWheel);
  }, []);

  const cPages = isPrint
    ? !Array.isArray(pages) || pages.length === 0
      ? [[]]
      : pages
    : [0];

  const checkifVisible = (status: number, index: number) => {
    if (!isPrint || hasTicket) return true;
    switch (status) {
      case 0:
        return isPrint;
      case 1:
        return index === 0;
      case 2:
        return index + 1 === cPages.length;
    }
  };

  return (
    <div
      ref={deskDiv}
      className="stationeryDesk"
      style={{
        justifyContent: flexDir[0] ? undefined : "center",
        alignItems: flexDir[1] ? undefined : "center",
        // room for the rulers outside the page's top and left edge
        padding: isPrint ? undefined : rulerSize + 4,
      }}
    >
      <div>
        <div
          style={hasTicket ? { display: "flex", flexWrap: "wrap" } : {}}
          ref={printArea}
        >
          {cPages.map((v: stdObject, index: number) => (
            <div
              ref={pageDiv}
              key={index}
              className={isPrint ? "stationeryPaperPrint" : "stationeryPaper"}
              style={{
                width: paperData.data.ANCDOC,
                height: paperData.data.ALTDOC,
                zoom: scaleInfo,
                isolation: isPrint ? undefined : "isolate",
              }}
            >
              {!isPrint && (
                <PageRuler
                  width={Number(paperData.data.ANCDOC)}
                  height={Number(paperData.data.ALTDOC)}
                  scale={scaleInfo}
                />
              )}
              {isDoc && <InnerTable lines={v} />}
              {paperData.parts
                .filter((e: stdObject) => e.TIPPAR !== 4 && actives[e.NUMPAR])
                .map(
                  (e: stdObject, idx: number) =>
                    checkifVisible(e.PAGPAR, index) && (
                      <EditableItem
                        key={idx}
                        e={e}
                        currPage={index + 1}
                        totalPage={cPages.length}
                        ticketData={hasTicket ? cPages[index] : {}}
                      />
                    ),
                )}
            </div>
          ))}
        </div>
        <div style={{ height: 15 }}></div>
      </div>
    </div>
  );
}
